export default "__VITE_ASSET__DCX8D2Ur__"